let EMRs = [
  'Patagonia Health',
  'Kareo',
  'EMA / Modernizing Medicine',
  'Practice Fusion',
  'NEMO Health / TrakNet',
  'eClinicalWorks (Web App)',
  'eClinicalWorks (Desktop App)',
  'Simple Practice',
  'Epic',
  'Athenahealth',
  'NexTech / MDIntellsys',
  'DocuTAP',
  'TherapyNotes',
  'AdvancedMD',
  'Aprima',
  'Point Click Care',
  'Netsmart',
  'PrimeSUITE',
  'NextGen',
  'Care Cloud',
  'Centricity',
  'Gmed',
  'Theranest',
  'WebPT',
  'Icanotes',
  'Talk EHR',
  'MacPractice',
  'Allscripts',
  'Experity',
  'Practice Mate',
  'Office Ally',
  'DrChrono',
  'Nymbl Systems',
  'PillHelp Works',
  'Method One',
  'Prognocis',
  'Brightree',
  'Sunwave',
  'Medics Cloud',
  'Care Logic',
  'Elation',
  'Care Tracker',
  'OncoEMR',
  'Ognomy',
  'CharmEHR',
];

EMRs.sort();
EMRs.push('Other');

export const SortedEMRs = EMRs;

const AILabels = [
  'Referral',
  'Pharmacy Request',
  'Prior Authorization',
  'Lab Result',
  'Consult Note',
  'Imaging Result',
  'Discharge Summary',
  'Clinical Notes',
  'Orders',
];

AILabels.sort();

export const SortedAILabels = AILabels;

// Add new function to get AI labels based on feature flag
export const getAILabels = async () => {
  try {
    const { verifyFeatureAccess } = await import('../../global/featureFlags');
    const hasBiologicsFeature = await verifyFeatureAccess('biologics_detection');
    
    const baseLabels = [...AILabels];
    if (hasBiologicsFeature) {
      baseLabels.push('Biologics');
    }
    
    return baseLabels.sort();
  } catch (error) {
    // Fallback to base labels if feature flag check fails
    console.warn('Failed to check biologics feature flag, using base AI labels:', error);
    return AILabels;
  }
};

const InboundFeature = "Get faxes straight into the patient's chart";
const OutboundFeature = 'Send faxes and emails from your EMR in 1-click';

export const SupportedEMRs = [
  { emr: 'Kareo', supportedFeatures: [OutboundFeature, InboundFeature] },
  { emr: 'eClinicalWorks (Web App)', supportedFeatures: [OutboundFeature, InboundFeature] },
  { emr: 'EMA / Modernizing Medicine', supportedFeatures: [InboundFeature] },
  { emr: 'Athenahealth', supportedFeatures: [OutboundFeature] },
  { emr: 'DrChrono', supportedFeatures: [OutboundFeature, InboundFeature] },
  { emr: 'Practice Fusion', supportedFeatures: [InboundFeature] },
  { emr: 'Nymbl Systems', supportedFeatures: [InboundFeature] },
  { emr: 'AdvancedMD', supportedFeatures: [InboundFeature, OutboundFeature] },
  { emr: 'Simple Practice', supportedFeatures: [InboundFeature, OutboundFeature] },
  { emr: 'WebPT', supportedFeatures: [InboundFeature, OutboundFeature] },
];
